import { useState, useEffect, useCallback } from "react";
import { CustomerTableData } from "src/shared/services/interfacev2";
import { getCustomer } from "src/shared/services/servicesv2";

interface UseCustomerDataOptions {
  showDeleted: boolean;
  searchTerm: string;
  page: number;
  rowsPerPage: number;
  sortField?: string;
  sortOrder?: string;
}

export const useCustomerData = ({ showDeleted, searchTerm, page, rowsPerPage, sortField, sortOrder }: UseCustomerDataOptions) => {
  const [customerData, setCustomerData] = useState<CustomerTableData>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>("");

  const fetchCustomers = useCallback(async () => {
    try {
      setLoading(true);
      setError("");
      const pageNumber = page + 1;
      const pageSize = rowsPerPage === -1 ? 1000 : rowsPerPage;

      const response = await getCustomer(showDeleted, pageNumber, pageSize, searchTerm.trim() || undefined, sortField, sortOrder);

      if (response.data) {
        setCustomerData(response.data);
      }
    } catch (err: any) {
      const errorMessage = err.response?.data?.message || "Failed to fetch customer data";
      setError(errorMessage);
      console.error("Error fetching customer data:", err);
    } finally {
      setLoading(false);
    }
  }, [showDeleted, searchTerm, page, rowsPerPage, sortField, sortOrder]);

  useEffect(() => {
    fetchCustomers();
  }, [fetchCustomers]);

  return { customerData, loading, error, refetch: fetchCustomers };
};
